<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Mirror" }}</div>
      </div>
    </div>
    <!---->
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the mirror config." }}
      </p>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <block-cntr
          :btitle="'mirror config'"
          style="height: 100%"
          :closeButton="false"
        >
          <!--配置按钮-->
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in mirrorConfigTable"
                :key="row.dstPort"
                :class="{ 'true:': true }"
              >
                <td>
                  <div>{{ row.dstPort }}</div>
                </td>
                <td>
                  <div>{{ row.srcEgressPorts }}</div>
                </td>
                <td>
                  <div>{{ row.srcIngressPorts }}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--Mirror配置-->
          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'mirror config'"
              style="min-height: 100%"
              @close="isShowAddTable = false"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-4 control-label" for="dstPort"
                    >Monitor Port</label
                  >
                  <div class="col-sm-5" id="dstPort">
                    <select
                      class="form-control"
                      v-model="mirrorConfigForm.dstPort"
                    >
                      <option value="">None</option>
                      <option
                        v-for="n in devicePort.gponPortNum"
                        :key="n"
                        :value="'g0/' + n"
                      >
                        g0/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.gePortNum"
                        :key="n"
                        :value="'e1/' + n"
                      >
                        e1/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.xgePortNum"
                        :key="n"
                        :value="'e2/' + n"
                      >
                        e2/{{ n }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-4 control-label" for="srcPortEg"
                    >Mirrored Egress Ports</label
                  >
                  <div class="col-sm-5" id="srcPortEg">
                    <select
                      class="form-control"
                      v-model="mirrorConfigForm.srcEgressPorts"
                    >
                      <option value="">None</option>
                      <option
                        v-for="n in devicePort.gponPortNum"
                        :key="n"
                        :value="'g0/' + n"
                      >
                        g0/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.gePortNum"
                        :key="n"
                        :value="'e1/' + n"
                      >
                        e1/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.xgePortNum"
                        :key="n"
                        :value="'e2/' + n"
                      >
                        e2/{{ n }}
                      </option>
                      <option :value="'cpu'">cpu</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-4 control-label" for="srcPortIn"
                    >Mirrored Ingress Ports</label
                  >
                  <div class="col-sm-5" id="srcPortIn">
                    <select
                      class="form-control"
                      v-model="mirrorConfigForm.srcIngressPorts"
                    >
                      <option value="">None</option>
                      <option
                        v-for="n in devicePort.gponPortNum"
                        :key="n"
                        :value="'g0/' + n"
                      >
                        g0/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.gePortNum"
                        :key="n"
                        :value="'e1/' + n"
                      >
                        e1/{{ n }}
                      </option>
                      <option
                        v-for="n in devicePort.xgePortNum"
                        :key="n"
                        :value="'e2/' + n"
                      >
                        e2/{{ n }}
                      </option>
                      <option :value="'cpu'">cpu</option>
                    </select>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  data() {
    return {
      isShowAddTable: false,
      iBox: {},
      devicePort: "",
      title: "",
      mirrorConfigTable: "",
      mirrorConfigForm: {
        dstPort: "",
        srcEgressPorts: "",
        srcIngressPorts: "",
      },
    }
  },
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  created() {
    this.loadDevicePort()
    this.loadMirrorConfiguration()
  },
  methods: {
    /*获取设备端口信息*/
    loadDevicePort() {
      get("devicePortInfo")
        .then((res) => (this.devicePort = res.data))
        .catch((err) => {})
    },
    /*获取配置信息*/
    loadMirrorConfiguration() {
      get("mirrorConfiguration")
        .then((res) => {
          console.log(res)
          this.title = res.data.title
          this.mirrorConfigTable = res.data.data
        })
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
    },
    clkEdit() {
      //this.mirrorConfigForm.dstPort = this.mirrorConfigTable[0].dstPort
      //this.mirrorConfigForm.srcEgressPorts = this.mirrorConfigTable[0].srcEgressPorts
      //this.mirrorConfigForm.srcIngressPorts = this.mirrorConfigTable[0].srcIngressPorts
      //this.mirrorConfigForm.trueEgressPorts = this.mirrorConfigTable[0].trueEgressPorts
      this.isShowAddTable = true
      this.mirrorConfigForm.dstPort = ""
      this.mirrorConfigForm.srcEgressPorts = ""
      this.mirrorConfigForm.srcIngressPorts = ""
    },

    /*清除镜像配置*/
    clkDel() {
      post("mirrorClearConfig")
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadMirrorConfiguration()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },
    /*镜像配置*/
    clkApply() {
      var mirrorCfg = {
        dstPort: this.mirrorConfigForm.dstPort,
        srcEgressPorts: this.mirrorConfigForm.srcEgressPorts,
        srcIngressPorts: this.mirrorConfigForm.srcIngressPorts,
      }
      if (this.mirrorConfigForm.dstPort == "") {
        this.showAlertBox("warn", "Message", "Invalid monitor port")
        return
      }
      if (
        mirrorCfg.dstPort == mirrorCfg.srcEgressPorts ||
        mirrorCfg.dstPort == mirrorCfg.srcIngressPorts
      ) {
        this.showAlertBox(
          "warn",
          "Message",
          "Mirrored port can't be same as monitor port"
        )
        return
      }

      console.log(mirrorCfg)

      /*清除镜像配置*/
      this.clkDel()

      post("mirrorConfig", mirrorCfg)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadMirrorConfiguration()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.loadMirrorConfiguration()
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>